var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDiyUpdateBtn },
                        },
                        [_vm._v("修改信息")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listSyncBtn },
                        },
                        [_vm._v("同步数据")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_materielId",
                                attrs: {
                                  code: "materielId",
                                  name: "物料ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "materielId", $$v)
                                  },
                                  expression: "data.head['materielId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielCode",
                                attrs: {
                                  code: "materielCode",
                                  name: "物料编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "materielCode", $$v)
                                  },
                                  expression: "data.head['materielCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_materielName",
                                attrs: {
                                  url: "base/dictionary/medicinedic/materiel/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  code: "materielName",
                                  name: "物料名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["materielName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "materielName", $$v)
                                  },
                                  expression: "data.head['materielName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_storeId",
                                attrs: {
                                  code: "storeId",
                                  name: "门店ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["storeId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeId", $$v)
                                  },
                                  expression: "data.head['storeId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_storeCode",
                                attrs: {
                                  url: "base/user/user/store/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "storeCode",
                                  name: "门店编码",
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["storeCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeCode", $$v)
                                  },
                                  expression: "data.head['storeCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_storeName",
                                attrs: {
                                  code: "storeName",
                                  name: "门店名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["storeName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeName", $$v)
                                  },
                                  expression: "data.head['storeName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielDescribe",
                                attrs: {
                                  code: "materielDescribe",
                                  name: "物料描述",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielDescribe"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielDescribe",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielDescribe']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_pinyinCode",
                                attrs: {
                                  code: "pinyinCode",
                                  name: "拼音码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["pinyinCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "pinyinCode", $$v)
                                  },
                                  expression: "data.head['pinyinCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_materielTypeSign",
                                attrs: {
                                  code: "materielTypeSign",
                                  name: "类型标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.typeSign),
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielTypeSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielTypeSign",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielTypeSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielIotCode",
                                attrs: {
                                  code: "materielIotCode",
                                  name: "条码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielIotCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielIotCode",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielIotCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielInsuranceCode",
                                attrs: {
                                  code: "materielInsuranceCode",
                                  name: "医保码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielInsuranceCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielInsuranceCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielInsuranceCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_dicWeight",
                                attrs: {
                                  code: "dicWeight",
                                  name: "词典权重",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["dicWeight"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "dicWeight", $$v)
                                  },
                                  expression: "data.head['dicWeight']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_batchType",
                                attrs: {
                                  code: "batchType",
                                  name: "批次管理模式",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.batchType),
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["batchType"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "batchType", $$v)
                                  },
                                  expression: "data.head['batchType']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_unitPriceType",
                                attrs: {
                                  code: "unitPriceType",
                                  name: "定价模式",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(
                                    _vm.jsonStr.unitPriceType
                                  ),
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["unitPriceType"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "unitPriceType",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['unitPriceType']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_unitPrice",
                                attrs: {
                                  code: "unitPrice",
                                  name: "销售定价",
                                  "default-value": 0,
                                  disabled:
                                    _vm.data.head["unitPriceType"] !== "1",
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["unitPrice"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "unitPrice", $$v)
                                  },
                                  expression: "data.head['unitPrice']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_unitPriceScale",
                                attrs: {
                                  code: "unitPriceScale",
                                  name: "加成比例",
                                  "default-value": 0,
                                  disabled:
                                    _vm.data.head["unitPriceType"] !== "2",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["unitPriceScale"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "unitPriceScale",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['unitPriceScale']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_materielMedUomId",
                                attrs: {
                                  code: "materielMedUomId",
                                  name: "药品单位ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedUomId"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedUomId",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielMedUomId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMedUomCode",
                                attrs: {
                                  code: "materielMedUomCode",
                                  name: "药品单位编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedUomCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedUomCode",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielMedUomCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMedUomName",
                                attrs: {
                                  code: "materielMedUomName",
                                  name: "药品单位名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedUomName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedUomName",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielMedUomName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_materielMedSpecId",
                                attrs: {
                                  code: "materielMedSpecId",
                                  name: "药品规格ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedSpecId"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedSpecId",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielMedSpecId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMedSpecCode",
                                attrs: {
                                  code: "materielMedSpecCode",
                                  name: "药品规格编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedSpecCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedSpecCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielMedSpecCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMedSpecName",
                                attrs: {
                                  code: "materielMedSpecName",
                                  name: "药品规格名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedSpecName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedSpecName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielMedSpecName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_materielMedDosageId",
                                attrs: {
                                  code: "materielMedDosageId",
                                  name: "药品剂型ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedDosageId"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedDosageId",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielMedDosageId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMedDosageCode",
                                attrs: {
                                  code: "materielMedDosageCode",
                                  name: "药品剂型编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedDosageCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedDosageCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielMedDosageCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMedDosageName",
                                attrs: {
                                  code: "materielMedDosageName",
                                  name: "药品剂型名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMedDosageName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMedDosageName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielMedDosageName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_materielMeaUomId",
                                attrs: {
                                  code: "materielMeaUomId",
                                  name: "计量单位ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMeaUomId"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMeaUomId",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielMeaUomId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMeaUomCode",
                                attrs: {
                                  code: "materielMeaUomCode",
                                  name: "计量单位编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMeaUomCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMeaUomCode",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielMeaUomCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielMeaUomName",
                                attrs: {
                                  code: "materielMeaUomName",
                                  name: "计量单位名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielMeaUomName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielMeaUomName",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['materielMeaUomName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_materielClassifyUomId",
                                attrs: {
                                  code: "materielClassifyUomId",
                                  name: "物料分类ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["materielClassifyUomId"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielClassifyUomId",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielClassifyUomId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_materielClassifyUomCode",
                                attrs: {
                                  code: "materielClassifyUomCode",
                                  name: "物料分类编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value:
                                    _vm.data.head["materielClassifyUomCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielClassifyUomCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielClassifyUomCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_materielClassifyUomName",
                                attrs: {
                                  code: "materielClassifyUomName",
                                  name: "物料分类名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value:
                                    _vm.data.head["materielClassifyUomName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "materielClassifyUomName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['materielClassifyUomName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_effectiveSign",
                                attrs: {
                                  code: "effectiveSign",
                                  name: "有效标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(
                                    _vm.jsonStr.effectiveSign
                                  ),
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["effectiveSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "effectiveSign",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['effectiveSign']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_materielMedDosageCode",
                                            attrs: {
                                              code: "materielMedDosageCode",
                                              name: "药品剂型编码",
                                              url: "base/dictionary/medicinedic/meddictionary/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {
                                                medDirectoryCode: "XJ",
                                              },
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "materielMedDosageCode"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielMedDosageCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielMedDosageCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_materielMedDosageName",
                                            attrs: {
                                              code: "materielMedDosageName",
                                              name: "药品剂型名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "materielMedDosageName"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielMedDosageName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielMedDosageName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_classifyUomCode",
                                            attrs: {
                                              code: "classifyUomCode",
                                              name: "物料分类编码",
                                              url: "base/dictionary/medicinedic/classifydictionary/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {},
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "materielClassifyUomCode"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielClassifyUomCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielClassifyUomCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_classifyUomName",
                                            attrs: {
                                              code: "classifyUomName",
                                              name: "物料分类名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "materielClassifyUomName"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielClassifyUomName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielClassifyUomName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_materielTypeSign",
                                            attrs: {
                                              code: "materielTypeSign",
                                              name: "类型标识",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.typeSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "materielTypeSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielTypeSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielTypeSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_pinyinCode",
                                            attrs: {
                                              code: "pinyinCode",
                                              name: "拼音码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["pinyinCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "pinyinCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['pinyinCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_materielIotCode",
                                            attrs: {
                                              code: "materielIotCode",
                                              name: "条码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["materielIotCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielIotCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielIotCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_materielInsuranceCode",
                                            attrs: {
                                              code: "materielInsuranceCode",
                                              name: "医保码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "materielInsuranceCode"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielInsuranceCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielInsuranceCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_unitPriceType",
                                            attrs: {
                                              code: "unitPriceType",
                                              name: "定价模式",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.unitPriceType
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["unitPriceType"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "unitPriceType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['unitPriceType']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_batchType",
                                            attrs: {
                                              code: "batchType",
                                              name: "批次管理模式",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.batchType
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["batchType"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "batchType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['batchType']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_effectiveSign",
                                            attrs: {
                                              code: "effectiveSign",
                                              name: "有效标识",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.effectiveSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["effectiveSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "effectiveSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['effectiveSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_materielTypeCode",
                                            attrs: {
                                              code: "materielTypeCode",
                                              name: "物料类型编码",
                                              url: "base/dictionary/medicinedic/materieltype/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "code",
                                              searcher: {},
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "materielTypeCode"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielTypeCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielTypeCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_materielCode",
                                            attrs: {
                                              code: "materielCode",
                                              name: "物料编码",
                                              url: "base/dictionary/medicinedic/materiel/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "code",
                                              searcher: {},
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["materielCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_materielName",
                                            attrs: {
                                              code: "materielName",
                                              name: "物料名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["materielName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "materielName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['materielName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-id", {
                        attrs: {
                          code: "materielId",
                          name: "物料ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielCode",
                          name: "物料编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielName",
                          name: "物料名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: { code: "storeId", name: "门店ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielDescribe",
                          name: "物料描述",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "dicWeight",
                          name: "词典权重",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "batchType",
                          name: "批次管理模式",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.batchType),
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "unitPriceType",
                          name: "定价模式",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.unitPriceType),
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "unitPrice",
                          name: "销售定价",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "unitPriceScale",
                          name: "加成比例",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "pinyinCode",
                          name: "拼音码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "effectiveSign",
                          name: "有效标识",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.effectiveSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "materielTypeSign",
                          name: "类型标识",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.typeSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielIotCode",
                          name: "条码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielInsuranceCode",
                          name: "医保码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "materielMedUomId",
                          name: "药品单位ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMedUomCode",
                          name: "药品单位编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMedUomName",
                          name: "药品单位名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "materielMedSpecId",
                          name: "药品规格ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMedSpecCode",
                          name: "药品规格编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMedSpecName",
                          name: "药品规格名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "materielMedDosageId",
                          name: "药品剂型ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMedDosageCode",
                          name: "药品剂型编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMedDosageName",
                          name: "药品剂型名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "materielMeaUomId",
                          name: "计量单位ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMeaUomCode",
                          name: "计量单位编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielMeaUomName",
                          name: "计量单位名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "materielClassifyUomId",
                          name: "物料分类ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielClassifyUomCode",
                          name: "物料分类编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "materielClassifyUomName",
                          name: "物料分类名称",
                          edit: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "物料信息",
            visible: _vm.dialogVisible,
            width: "50%",
            top: "16vh",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "enroll-dialog-form",
                  attrs: {
                    id: "enroll-dialog-form",
                    inline: true,
                    "label-width": "80px",
                    disabled: false,
                  },
                  model: {
                    value: _vm.data.head,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "head", $$v)
                    },
                    expression: "data.head",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_materielCode",
                            attrs: {
                              code: "materielCode",
                              name: "物料编码",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 50,
                              disabled: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["materielCode"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "materielCode", $$v)
                              },
                              expression: "data.head['materielCode']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_materielName",
                            attrs: {
                              code: "materielName",
                              name: "物料名称",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 50,
                              disabled: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["materielName"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "materielName", $$v)
                              },
                              expression: "data.head['materielName']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-select", {
                            ref: "input_unitPriceType",
                            attrs: {
                              code: "unitPriceType",
                              name: "定价模式",
                              "default-value": "",
                              "key-field": "key",
                              "value-field": "value",
                              options: _vm.toJson(_vm.jsonStr.unitPriceType),
                              disabled: false,
                              require: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["unitPriceType"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "unitPriceType", $$v)
                              },
                              expression: "data.head['unitPriceType']",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-number", {
                            ref: "dig_input_unitPrice",
                            attrs: {
                              code: "unitPrice",
                              name: "销售定价",
                              "default-value": 0,
                              disabled: _vm.data.head["unitPriceType"] !== "1",
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["unitPrice"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "unitPrice", $$v)
                              },
                              expression: "data.head['unitPrice']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-number", {
                            ref: "dig_input_unitPriceScale",
                            attrs: {
                              code: "unitPriceScale",
                              name: "加成比例",
                              "default-value": 0,
                              disabled: _vm.data.head["unitPriceType"] !== "2",
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["unitPriceScale"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "unitPriceScale", $$v)
                              },
                              expression: "data.head['unitPriceScale']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-select", {
                            ref: "input_effectiveSign",
                            attrs: {
                              code: "effectiveSign",
                              name: "有效标识",
                              "default-value": "",
                              "key-field": "key",
                              "value-field": "value",
                              options: _vm.toJson(_vm.jsonStr.effectiveSign),
                              disabled: false,
                              require: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["effectiveSign"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "effectiveSign", $$v)
                              },
                              expression: "data.head['effectiveSign']",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.updateInfo },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }